import { Component, Input, OnInit } from '@angular/core';
import { RenaultAnimationActionDetailSupervisorDTO } from '../../../models/renault-animation-action-dto';

@Component({
  selector: 'animation-action-result-distributor',
  templateUrl: './animation-action-result-distributor.component.html',
  styleUrls: ['./animation-action-result-distributor.component.scss']
})
export class AnimationActionResultDistributorComponent implements OnInit {
    
  @Input() model: RenaultAnimationActionDetailSupervisorDTO[];
  
  constructor() { }

  ngOnInit(): void {
    
  }
}
